import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedSection() {
  const featuredComics = comics.slice(0, 3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          编辑精选
        </h2>
        <p className="text-sm text-foreground-500 mt-1">品质好漫，不容错过</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {featuredComics.map((comic) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="group cursor-pointer rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={comic.cover}
                alt={`${comic.title} - 韩漫推荐`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-3 left-4">
                <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-background-50 dark:text-foreground-950">
                  精选
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                {comic.description}
              </p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-foreground-400">{comic.author}</span>
                <span className="text-xs text-secondary-600 flex items-center gap-1">
                  <i className="ri-eye-line"></i>{(comic.views / 10000).toFixed(1)}万
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}